function custProductSelected(obj){
  //obj: btn que tiene el data-show con el id de la imagen que tiene que mostrar
  $btnObj = $(obj);
  $btnObj.siblings("button").removeClass("selected");
  $btnObj.addClass("selected");
  toShow = $btnObj.data('show');
  $("img[data-img-name].visible").removeClass("visible");
  imgs = $("img[data-img-name=" + toShow + "]");
  imgs.addClass("visible")
  /*for (let index = 0; index < imgs.length; index++) {
    let element = imgs[index]; //vanilla js element
    element.scrollIntoView(false);
  }*/
  $(".btn-wrapper-container.visible").removeClass("visible");
  $(".btn-wrapper-container[data-for='" + toShow + "']").addClass("visible");
}

/*
Cuando se hacía un resize, al usar estar las dos imagenes renderizadas, no quedaba centrada una, había que volver a hacer el scrollIntoView.
El problema de eso era que cada vez que se hacía un resize, el scrollIntoView también scrollea verticalmente y siempre te llevaba a la sección Works in 3 Ways
$(document).ready(function(){
  $(window).resize(function(){
    let btnSelected = $("section.custom-image-with-text-left-v1 .cust-text-button-container .cust-buttons-container button.selected");
    if(btnSelected.length == 1){
      custProductSelected(btnSelected[0]);
    }
  });
});*/